import { ArContainer, ArSprite, screenDispatcher } from '@aceroll/core';

export class AdaptiveLogo extends ArContainer {
	#logo = null;
	#collisionObjectToCheck = null;

	constructor(collisionObjectToCheck) {
		super('adaptive-logo');
		this.#collisionObjectToCheck = collisionObjectToCheck;
		this.onResize = this.onResize.bind(this);
		this.#setup();
		this.#watchForResize();
		this.#checkCollisionAndUpdateVisibility();

	}

	#checkCollisionAndUpdateVisibility() {
		const isOverlapping = this.#isOverlapping();
		this.visible = !isOverlapping;
	}

	onPortrait() {
		this.#checkCollisionAndUpdateVisibility();
	}

	onLandscape() {
		this.#checkCollisionAndUpdateVisibility();
	}

	onResize() {
		this.#checkCollisionAndUpdateVisibility();
	}

	destroy() {
		screenDispatcher.offStateless('resize', this.onResize);
	}

	#isOverlapping() {
		if (!this.#collisionObjectToCheck || !this.#logo) {
			return false;
		}

		const logoBounds = this.#logo.getBounds();
		const objectToCheckBounds = this.#collisionObjectToCheck.getBounds();

		return (
			logoBounds.x < objectToCheckBounds.x + objectToCheckBounds.width &&
			logoBounds.x + logoBounds.width > objectToCheckBounds.x &&
			logoBounds.y < objectToCheckBounds.y + objectToCheckBounds.height &&
			logoBounds.y + logoBounds.height > objectToCheckBounds.y
		);
	}

	#setup() {
		this.#logo = ArSprite.from('common-game_logo');
		this.addChild(this.#logo);
	}

	#watchForResize() {
		screenDispatcher.onStateless('resize', this.onResize);
	}
}
